module.exports = __webpack_public_path__ + "img/app_whats.d1a7b8d8.png";